import { Dialog, DialogContent } from "./ui/dialog";
import { EvoluraLogo } from "./EvoluraLogo";

const GuestAuthGate = ({ open, onOpenChange, title, subtitle }) => {
  const handleGoogleLogin = () => {
    // Store that we're coming from guest mode so post-login migration can run
    const returnPath = `${window.location.pathname}${window.location.search || ''}`;
    sessionStorage.setItem("pending_return_url", returnPath);
    const params = new URLSearchParams();
    if (returnPath) params.set("return_url", returnPath);
    const qs = params.toString();
    window.location.href = `/api/auth/google/login${qs ? `?${qs}` : ""}`;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm p-0 rounded-2xl overflow-hidden" data-testid="guest-auth-gate">
        <div className="p-6 text-center">
          <div className="flex justify-center mb-4">
            <EvoluraLogo size={40} variant="dark" />
          </div>
          <h3 className="text-lg font-bold mb-1.5" style={{ color: "var(--color-text-primary)" }}>
            {title || "Sign in to save your progress"}
          </h3>
          <p className="text-sm mb-6" style={{ color: "var(--color-text-secondary)" }}>
            {subtitle || "Your work is safe — it will be saved automatically after signing in."}
          </p>
          <button
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-full border transition-colors hover:bg-slate-50"
            style={{ borderColor: "var(--color-border-default)" }}
            data-testid="guest-google-signin"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
              <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 6.29C4.672 4.163 6.656 2.58 9 2.58z" fill="#EA4335"/>
            </svg>
            <span className="text-sm font-semibold" style={{ color: "var(--color-text-primary)" }}>
              Continue with Google
            </span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GuestAuthGate;
